import React from 'react';

interface Props {
  buttonName: string;
  buttonText: string;
}

const FollowCollegesButton = ({buttonName, buttonText = 'Search Colleges'}: Props) => (
  <a className="shared-follow-more-colleges-button" href="/colleges" data-button-name={buttonName}>
    {buttonText}
  </a>
);

export default FollowCollegesButton;
